import React from 'react'
import { reduxForm } from 'redux-form'
import { generateValidation } from 'redux-form-validation'
import cx from 'classnames'
import groupBy from 'lodash/groupBy'
import sortBy from 'lodash/sortBy'
import moment from 'moment'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  CheckboxGroup,
  InlineCheckbox
} from '../modal-form/modal-form'

import { DataCard, Details, Dot, Title, TimeFrame } from '../data-card/data-card-parts'

import { CollectionButton } from '../buttons'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

const validations = {
  workOrderId: {
    required: true
  }
}

class TransferAreaModal extends React.Component {
  constructor(props) {
    super(props)
  }

  render () {
    const {
      fields: {
        workOrderId
      },
      loading,
      error,
      submitting,
      handleSubmit,
      handleClose,
      modalTitle,
      submitButtonText,
      sortedWorkOrders,
      workOrderKeys,
      hasNextPage,
      onLoadNextPage,

      getLocation
    } = this.props

    return (
      <BaseModal
        onClose={handleClose}
        title={modalTitle}
        constraints={constraints}
        contentClassName='transfer-area-modal-container'
      >
        <a id='top' />
        <ModalForm onSubmit={handleSubmit} customClassName='transfer-area-form'>
          <ModalFormRow>
            <ModalFormBlock>
              {<p className={cx({'centered': true, 'error': true, hidden: !error || submitting})}>
                {error && error.detail}
              </p>}
            </ModalFormBlock>
          </ModalFormRow>
          <ModalFormRow>
            <ul>
              {workOrderKeys.length > 0 && workOrderKeys.map((group, i) => (
                <li className='group' key={group}>
                  <p className='group-name'>{moment(group).format('dddd, MMMM Do, YYYY')}</p>
                  <ul>
                  {sortedWorkOrders[group].map((workOrder) => (
                    <li className='location' key={workOrder.id}>
                      <label>
                        <div className='radio-button-container'>
                          <input
                            type='radio'
                            {...workOrderId}
                            value={workOrder.id}
                            checked={workOrderId.value == workOrder.id}
                          />
                        </div>
                        <div className='info-container'>
                          <p className='location'>{`${getLocation(workOrder.location).name}`}</p>
                          <p className='date'>{`${workOrder.startsAt.format('h:mm A')} - ${workOrder.endsAt.format('h:mm A')}`}</p>
                        </div>
                      </label>
                    </li>
                  ))}
                  </ul>
                </li>
              ))}
            </ul>
          </ModalFormRow>
          <ModalFormRow>
            {hasNextPage &&
              <CollectionButton style={{ flexGrow: 1 }} onClick={onLoadNextPage}>See more...</CollectionButton>}
          </ModalFormRow>
          <ModalFormRow>
            <ModalFormBlock submitButton>
              <button type='submit' disabled={submitting}>{submitButtonText || 'Submit'}</button>
            </ModalFormBlock>
          </ModalFormRow>
        </ModalForm>
      </BaseModal>
    )
  }
}

export default reduxForm({
  form: 'tranferAreaToWorkOrder',
  ...generateValidation(validations)
})(TransferAreaModal)



// WEBPACK FOOTER //
// ./src/components/work-orders/transfer-area-modal.js